(() => {
  if (customElements.get('pw-collection-quick-shop')) return;
  customElements.define('pw-collection-quick-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const button = this.querySelector('button');
      const status = this.querySelector('[role="status"]');
      const error = this.querySelector('[role="alert"]');
      button.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (button.disabled || this.busy) return;
        this.busy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.classList.remove('is-added');
        error.hidden = true;
        status.textContent = button.dataset.adding;
        try {
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const body = new FormData();
          body.append('id', button.dataset.variantId);
          body.append('quantity', '1');
          if (cart) {
            body.append('sections', cart.getSectionsToRender().map(section => section.id));
            body.append('sections_url', location.pathname);
            cart.setActiveElement(button);
          }
          const response = await fetch(button.dataset.addUrl, {
            method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || button.dataset.error);
          button.classList.add('is-added');
          setTimeout(() => button.classList.remove('is-added'), 1600);
          status.textContent = button.dataset.added;
          if (cart) {
            cart.classList.remove('is-empty');
            cart.renderContents(result);
          } else location.assign(button.dataset.cartUrl);
        } catch (e) {
          error.textContent = e.message || button.dataset.error;
          error.hidden = false;
        } finally {
          this.busy = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    }
  });
})();
